import React, { useEffect, useState } from "react";
import { Container, Button, Form, InputGroup } from "react-bootstrap";
import { ValidationMessage } from "../../utils/constants/validationMessage";
import { useForm } from "react-hook-form";
import { regex } from "../../utils/constants/regexVariables";
import { whiteSpaceCheck } from "../../helper/helper";
import { ErrorMessage } from "@hookform/error-message";
import { forgetPasswordApi } from "../../hooks/ApisContainer/Auth";
import useToastContext from "../../hooks/useToastContext";
import { useNavigate } from "react-router-dom";
import { Loader } from "lucide-react";

const ForgotPassword = () => {
  const notification = useToastContext();
  const navigate = useNavigate();
  const Token = localStorage.getItem("token");
  const userType = localStorage.getItem("user-type");
  // HOOK FORM
  const {
    register,
    setValue,
    clearErrors,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm();

  // ALL STATE
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (Token) {
      if (userType == "member") {
        navigate("/member-info");
      } else {
        navigate("/dashboard");
      }
    }
  }, [Token]);

  const onSubmit = (data) => {
    const requestPayload = { ...data };

    forgetPasswordApi(requestPayload, notification, (loading, error) => {
      setLoader(loading);
      if (!error) {
        setValue("email", "");
      }
    });
  };

  return (
    <section className="login-sec for-mobile">
      <Container>
        <Form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
          <div className="wrapper">
            <div className="common-heading text-center mb-4">
              <h2>Forgot Password ?</h2>
            </div>
            <Form.Group className="mb-4">
              <Form.Control
                type="email"
                placeholder="Email"
                name="email"
                {...register("email", {
                  required: ValidationMessage.EMAIL_REQUIRED,
                  pattern: {
                    value: regex.regEmail,
                    message: ValidationMessage.ENTER_VALID_EMAIL,
                  },
                })}
              />

              <ErrorMessage
                errors={errors}
                name="email"
                render={({ message }) => (
                  <p className="error-message text-start py-2 px-1 text-danger">
                    {message}
                  </p>
                )}
              />
            </Form.Group>

            <Button
              type="submit"
              className="themeht-btn btn w-100 py-2 mt-3"
              disabled={loader}
              style={loader ? { cursor: "not-allowed" } : { cursor: "pointer" }}
            >
              <span className="d-flex fs-6 justify-content-center align-items-center">
                Submit{" "}
                {loader && (
                  <Loader
                    style={{
                      marginLeft: "20px",
                    }}
                    className="loader"
                  />
                )}
              </span>
            </Button>
            <div className="dont-have-account pt-4 text-center">
              <h4>
                Return to? <a href="/login">Login</a>
              </h4>
            </div>
          </div>
        </Form>
      </Container>
    </section>
  );
};

export default ForgotPassword;
